import { IGlobalOrderDetails } from '@interfaces/myPurchasesInterfaces';

import { getLabelFallback } from '@utils/utils';

interface Props {
    orderDetail: IGlobalOrderDetails;
}
const PaymentDetailsOrderDetail = ({ orderDetail }: Props): JSX.Element => {
    const {
        shippingMethod,
        shippingAddress,
        billingAddress,
        paymentMethod,
        subtotal,
        orderTotal,
        shippingCost,
        taxes,
        orderStatus,
        paymentMethodId,
        hasContactLenses
    } = orderDetail;
    return (
        <div className={`payment-container ${orderStatus != 'D' && 'large'}`}>
            <div className="payment-detail online">
                <div className="shipping-payment-overview">
                    <div className="secondary-message large bold align-left">
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_OVERVIEW_TITLE'
                        )}
                    </div>
                    <div className="informations">
                        <span className="secondary-message bold medium align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_SHIPPING_METHOD'
                            )}
                        </span>
                        <div className="secondary-message medium align-left">
                            {(() => {
                                if (shippingMethod?.toLowerCase() === 'ground' && !hasContactLenses) {
                                    return getLabelFallback('RESPONSIBLE_SHIPPING_LABEL');
                                }
                                return shippingMethod;
                            })()}
                        </div>

                        <>
                            <span className="secondary-message bold medium align-left">
                                {getLabelFallback(
                                    shippingMethod.includes('Collect in store')
                                        ? 'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_RECIPIENT_DETAILS'
                                        : 'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_SHIPPING_ADDRESS'
                                )}
                            </span>
                            <div className="secondary-message  medium align-left">
                                {shippingAddress}
                            </div>
                        </>

                        <span className="secondary-message bold medium align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_BILLING_ADDRESS'
                            )}
                        </span>
                        <div className="secondary-message  medium align-left">{billingAddress}</div>
                        <span className="secondary-message bold medium align-left" style={{ marginBottom: '24px' }}>
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_PAYMENT_METHOD'
                            )}
                        </span>
                        <div className="secondary-message  medium align-left" style={{ marginBottom: '24px' }}>
                            {!!paymentMethodId?.toLowerCase().includes('amex') 
                                ? <svg className="icon"><use xlinkHref="#cc-amex"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('americanexpress')
                                ? <svg className="icon"><use xlinkHref="#cc-amex"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('discovercard')
                                ? <svg className="icon"><use xlinkHref="#cc-discover"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('master card')
                                ? <svg className="icon"><use xlinkHref="#cc-mastercard"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('mastercard')
                                ? <svg className="icon"><use xlinkHref="#cc-mastercard"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('paypal')
                                ? <svg className="icon"><use xlinkHref="#cc-paypal"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('visa')
                                ? <svg className="icon"><use xlinkHref="#cc-visa"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('afterpay')
                                ? <svg className="icon"><use xlinkHref="#cc-afterpay"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('toafterpay')
                                ? <svg className="icon"><use xlinkHref="#cc-afterpay"></use></svg>
                                : !!paymentMethodId?.toLowerCase().includes('toapplepay')
                                ? <svg className="icon"><use xlinkHref="#cc-applepay"></use></svg>
                                : ''
                            }
                            {!!paymentMethod && paymentMethod !== '' ? paymentMethod : 'OTHER'}
                        </div>
                    </div>
                </div>
                <div className="expense-report">
                    <div className="row">
                        <span className="secondary-message bold large align-left">
                            {getLabelFallback(
                                'IN_STORE_PURCHASES_MY_PURCHASES_TOTAL'
                            )}
                        </span>
                    </div>
                    <div className="row">
                        <span className="secondary-message bold large align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_DETAILS_SUBTOTAL'
                            )}
                        </span>
                        <div className="secondary-message large align-right">{subtotal}</div>
                    </div>
                    <div className="row">
                        <span className="secondary-message bold large align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_SHIPPING_COST'
                            )}
                        </span>
                        <div className="secondary-message large align-right">{shippingCost}</div>
                    </div>
                    <div className="row">
                        <span className="secondary-message bold large align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_TAXES'
                            )}
                        </span>
                        <div className="secondary-message large align-right">{taxes}</div>
                    </div>
                    <div className="row">
                        <span className="secondary-message bold large align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAYMENT_ORDER_TOTAL'
                            )}
                        </span>
                        <div className="secondary-message large align-right">{orderTotal}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PaymentDetailsOrderDetail;
